import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import AvatarPlaceholder from '../../assets/AvatarPlaceholder.svg';

/** Avatar in a walnut bezel — 2px ring + lit top edge, matching the pieces. */
const useStyles = createUseStyles({
  container: {
    width: ({ size }) => size ?? 60,
    height: ({ size }) => size ?? 60,
    boxSizing: 'border-box',
    overflow: 'hidden',
    background: ({ color }) => color ?? '#d94f2b',
    border: '2px solid #120c07',
    borderRadius: '100%',
    flexShrink: 0,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.28), 0 1px 2px rgba(0,0,0,0.35)',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

function Avatar({ photoURL, color, size }) {
  const theme = useTheme();
  const classes = useStyles({ theme, color, size });

  // `photoURL` has had no source since Facebook auth was removed, so this is
  // the placeholder in practice — the prop stays for whatever fills it next.
  // See client/docs/firebase-facebook.md.
  const image = photoURL || AvatarPlaceholder;

  return (
    <div className={classes.container}>
      <img src={image} alt="avatar" className={classes.image} />
    </div>
  );
}

export default Avatar;
